export default "__VITE_ASSET__DAGmmd39__"